import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IResponse } from 'src/app/pages/base/interfaces';
import { TransaccionModel } from '../transaccion.model';
import { RendicionCajaService } from 'src/app/services/tesoreria/rendicion_caja.service';
import { Detalle } from '../base.model';


export class RendicionCaja extends TransaccionModel {

    public static RECORD_NAME = 'rendiciones_caja';
    public static CODIGO_REGISTRO = 'rendicion_caja';
    public static CODIGO_MODULO = 'tesoreria';
    public static NOMBRE_SINGULAR = 'Rendición de Caja';
    public static NOMBRE_PLURAL = 'Rendiciones de Caja';
    public static INGRESO = 1;
    public static EGRESO = 2;


    private _idEmpresa: number;
    private _nombreEmpresa: string;
    private _idSucursal: number;
    private _nombreSucursal: string;
    private _idCajero: number;
    private _codigoCajero: string;
    private _nombreCajero: string;
    private _comentario: string;
    private _saldoAnterior: number;
    private _totalIngresos: number;
    private _totalEgresos: number;
    private _totalSaldo: number;
    private _saldoActual: number;
    private _faltanteSobrante: number;
    private _totalValores: number;

    private _detalles: RendicionCajaDetalle[] | Record<string, any>[];
    private _valores: RendicionCajaValor[] | Record<string, any>[];


    constructor() {
        super();
        const currentUser = this.seguridad.getCurrentUser();
        this._idEmpresa = currentUser?.id_empresa;
        this._nombreEmpresa = currentUser?.nombre_empresa;
        this._idSucursal = currentUser?.id_sucursal;
        this._nombreSucursal = currentUser?.nombre_sucursal;
        if ( currentUser?.cajero ) {
            this._idCajero = currentUser?.id;
            this._codigoCajero = currentUser?.codigo;
            this._nombreCajero = currentUser?.nombre;
        }
        this._saldoAnterior = 0;
        this._totalIngresos = 0;
        this._totalEgresos = 0;
        this._totalSaldo = 0;
        this._saldoActual = 0;
        this._faltanteSobrante = 0;
        this._totalValores = 0;

        this._detalles = [];
        this._valores = [];
    }

    public set idEmpresa( idEmpresa: number ) { this._idEmpresa = idEmpresa };
    public get idEmpresa(): number { return this._idEmpresa };

    public set nombreEmpresa( nombreEmpresa: string ) { this._nombreEmpresa = nombreEmpresa };
    public get nombreEmpresa(): string { return this._nombreEmpresa };

    public set idSucursal( idSucursal: number ) { this._idSucursal = idSucursal };
    public get idSucursal(): number { return this._idSucursal };

    public set nombreSucursal( nombreSucursal: string ) { this._nombreSucursal = nombreSucursal };
    public get nombreSucursal(): string { return this._nombreSucursal };

    public set idCajero( idCajero: number ) { this._idCajero = idCajero };
    public get idCajero(): number { return this._idCajero };

    public set codigoCajero( codigoCajero: string ) { this._codigoCajero = codigoCajero };
    public get codigoCajero(): string { return this._codigoCajero };

    public set nombreCajero( nombreCajero: string ) { this._nombreCajero = nombreCajero };
    public get nombreCajero(): string { return this._nombreCajero };

    public set comentario( comentario: string ) { this._comentario = comentario };
    public get comentario(): string { return this._comentario };

    public set saldoAnterior( saldoAnterior: number ) { this._saldoAnterior = saldoAnterior };
    public get importeApertura(): number { return this._saldoAnterior };

    public set totalIngresos( totalIngresos: number ) { this._totalIngresos = totalIngresos };
    public get totalIngresos(): number { return this._totalIngresos };

    public set totalEgresos( totalEgresos: number ) { this._totalIngresos = totalEgresos };
    public get totalEgresos(): number { return this._totalEgresos }

    public set totalSaldo( totalSaldo: number ) { this._totalSaldo = totalSaldo };
    public get totalSaldo(): number { return this._totalSaldo };

    public set saldoActual( saldoActual: number ) { this._saldoActual = saldoActual };
    public get saldoActual(): number { return this._saldoActual };

    public set faltanteSobrante( faltanteSobrante: number ) { this._faltanteSobrante = faltanteSobrante };
    public get faltanteSobrante(): number { return this._faltanteSobrante };

    public set totalValores( totalValores: number ) { this._totalValores = totalValores };
    public get totalValores(): number { return this._totalValores };

    public set detalles( detalles: Record<string, any>[] ) { this._detalles = detalles };
    public get detalles() { return this._detalles };

    public set valores( valores: Record<string, any>[] ) { this._valores = valores };
    public get valores() { return this._valores };


    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'nro_transaccion', label: 'Nro. Trx.', type: 'number' },
            { field: 'nombre_sucursal', label: 'Sucursal', type: 'text' },
            { field: 'nombre_cajero', label: 'Cajero', type: 'text' },
        ]
    }

    async cargarDatos( objeto: Record<string, any> ) {
        this._idEmpresa = objeto?.id_empresa;
        this._nombreEmpresa = objeto?.nombre_empresa;
        this._idSucursal = objeto?.id_sucursal;
        this._nombreSucursal = objeto?.nombre_sucursal;
        this._idCajero = objeto?.id_cajero;
        this._codigoCajero = objeto?.codigo_cajero;
        this._nombreCajero = objeto?.nombre_cajero;
        this._comentario = objeto?.comentario;
        this._saldoAnterior = objeto?.saldo_anterior;
        this._totalIngresos = objeto?.total_ingresos;
        this._totalEgresos = objeto?.total_egresos;
        this._totalSaldo = objeto?.total_saldo;
        this._saldoActual = objeto?.saldo_actual;
        this._faltanteSobrante = objeto?.faltante_sobrante;
        this._totalValores = objeto?.total_valores;
    }

    async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        await this.cargarDatos( objeto );
        this.detalles = objeto.detalles;
        this.valores = objeto.valores;
    }

    async actualizarDatos( objeto: Record< string, any> ) {
        await super.actualizarDatos( objeto );
        await this.cargarDatos( objeto );
        this.detalles = objeto.detalles;
        this.valores = objeto.valores;
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("id_empresa", new FormControl(this._idEmpresa, Validators.required));
        fg.addControl("nombre_empresa", new FormControl(this._nombreEmpresa));
        fg.addControl("id_sucursal", new FormControl(this._idSucursal, Validators.required));
        fg.addControl("nombre_sucursal", new FormControl(this._nombreSucursal, Validators.required));
        fg.addControl("id_cajero", new FormControl(this._idCajero, Validators.required));
        fg.addControl("codigo_cajero", new FormControl(this._codigoCajero, Validators.required));
        fg.addControl("nombre_cajero", new FormControl(this._nombreCajero, Validators.required));
        fg.addControl("comentario", new FormControl(this._comentario));
        fg.addControl("saldo_anterior", new FormControl(this._saldoAnterior));
        fg.addControl("total_ingresos", new FormControl(this._totalIngresos));
        fg.addControl("total_egresos", new FormControl(this._totalEgresos));
        fg.addControl("total_saldo", new FormControl(this._totalSaldo));
        fg.addControl("saldo_actual", new FormControl(this._saldoActual));
        fg.addControl("faltante_sobrante", new FormControl(this._faltanteSobrante));
        fg.addControl("total_valores", new FormControl(this._totalValores));

        fg.addControl("detalles", await this.cargarDetalles() );
        fg.addControl("valores", await this.cargarValores() );
        
        return fg;
    }

    async cargarDetalles() {
        const array = new FormArray([]);
        for (const objeto of this._detalles) {
            const obj = new RendicionCajaDetalle();
            await obj.cargarObjeto(objeto);
            array.push( await obj.getFormGroup() );
        }
        return array;
    }

    async cargarValores() {
        const array = new FormArray([]);
        for (const objeto of this._valores) {
            const obj = new RendicionCajaValor();
            await obj.cargarObjeto(objeto);
            array.push( await obj.getFormGroup() );
        }
        return array;
    }

    async guardar( service: RendicionCajaService ): Promise<IResponse> {
        return await service.post( this.serverJson );
    }

    async actualizar( service: RendicionCajaService  ): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    async eliminar( service: RendicionCajaService ): Promise<IResponse> {
        return await service.delete(this.id);
    }

}

// CLASE INGRESO
export class RendicionCajaDetalle extends Detalle {

    private _idRendicionCaja: number;
    private _idEmpresa: number;
    private _idConcepto: number;
    private _nombreConcepto: string;
    private _tipoConcepto: number;
    // private _comentario: string;
    // private _referencia: string;
    private _monto: number;
    // private _saldoActual: number;


    constructor() {
        super();
        this._monto = 0;
        // this._saldoActual = 0;
    }

    public set idConcepto( idConcepto: number ) { this._idConcepto = idConcepto };
    public get idConcepto() { return this._idConcepto };

    public set nombreConcepto( nombreConcepto: string ) { this._nombreConcepto = nombreConcepto };
    public get nombreConcepto() { return this._nombreConcepto };

    public set tipoConcepto( tipoConcepto: number ) { this._tipoConcepto = tipoConcepto };
    public get tipConcepto() { return this._tipoConcepto };

    public set monto( monto: number ) { this._monto = monto };
    public get mont() { return this._monto };
    

    async getFormGroup(): Promise<FormGroup> {
        const fg = await super.getFormGroup();
        fg.addControl("id_rendicion_caja", new FormControl(this._idRendicionCaja));
        fg.addControl("id_empresa", new FormControl(this._idEmpresa));
        fg.addControl("id_concepto", new FormControl(this._idConcepto));
        fg.addControl("nombre_concepto", new FormControl(this._nombreConcepto));
        fg.addControl("tipo_concepto", new FormControl(this._tipoConcepto));
        // fg.addControl("comentario", new FormControl(this._comentario));
        // fg.addControl("referencia", new FormControl(this._referencia));
        fg.addControl("monto", new FormControl(this._monto));
        // fg.addControl("saldo_actual", new FormControl(this._saldoActual));
        return fg;
    }

    async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        this._idRendicionCaja = objeto.id_rendicion_caja;
        this._idEmpresa = objeto.id_empresa;
        this._idConcepto = objeto.id_concepto;
        this._nombreConcepto = objeto.nombre_concepto;
        this._tipoConcepto = objeto.tipo_concepto;
        // this._comentario = objeto.comentario;
        // this._referencia = objeto.referencia;
        this._monto = objeto.monto;
        // this._saldoActual = objeto.saldo_actual ? objeto.saldo_actual : 0;
    }

}


// CLASE EFECTIVO
export class RendicionCajaValor extends Detalle {

    private _idRendicionCaja:  number;
    private _idEmpresa:  number;
    private _valor: number;
    private _cantidad: number;
    private _monto: number;

    constructor() {
        super();
        this._cantidad = 0;
        this._monto = 0;
    }

    get valor(): number {
        return this._valor;
    }

    async getFormGroup(): Promise<FormGroup> {
        const fg = await super.getFormGroup();
        fg.addControl("id_empresa", new FormControl(this._idEmpresa));
        fg.addControl("id_rendicion_caja", new FormControl(this._idRendicionCaja));
        fg.addControl("valor", new FormControl(this._valor));
        fg.addControl("cantidad", new FormControl(this._cantidad));
        fg.addControl("monto", new FormControl(this._monto));
        return fg;
    }

    async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        this._idEmpresa = objeto?.id_empresa;
        this._idRendicionCaja = objeto?.id_rendicion_caja;
        this._valor = objeto?.valor;
        this._monto = objeto?.monto;
        this._cantidad = objeto?.cantidad;
    }


}

